module.exports = __webpack_public_path__ + "static/media/derek_wang.2787038a.png";